import notificationItemConnector from "../notification-item-connector"
import NotificationViewItem from "./NotificationViewItem"

export default notificationItemConnector(NotificationViewItem)
